export const mapToSortArr = (map) =>
  Array.from(map.values()).sort((a, b) => b.count - a.count);
